

















































import Vue from "vue";
import Header from "../components/Header.vue";

export default Vue.extend({
  name: "Home",
  components: { Header },
  computed: {
    calculadoras() {
      return [
        {
          to: "/imc",
          icon: "⚖️",
          title: this.$t("home.imc_title"),
          desc: this.$t("home.imc_desc"),
        },
        {
          to: "/Grasa-Corporal",
          icon: "🔬",
          title: this.$t("home.grasa_title"),
          desc: this.$t("home.grasa_desc"),
        },
        {
          to: "/Calorias-Diarias",
          icon: "⚡",
          title: this.$t("home.calorias_title"),
          desc: this.$t("home.calorias_desc"),
        },
        {
          to: "/Macros-Diarios",
          icon: "🥗",
          title: this.$t("home.macros_title"),
          desc: this.$t("home.macros_desc"),
        },
      ];
    },
    pasos() {
      return [
        this.$t("home.step1"),
        this.$t("home.step2"),
        this.$t("home.step3"),
        this.$t("home.step4"),
      ];
    },
  },
});
